const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

/** Yerel upload (/api/files/...) ve harici URL'ler için görüntüleme adresi. */
export function mediaUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("blob:") || url.startsWith("data:")) {
    return url;
  }
  const path = url.startsWith("/") ? url : `/${url}`;
  const withHost = `${BACKEND}${path}`;
  const token = localStorage.getItem("renka_token");
  if (!token || !path.startsWith("/api/files/")) return withHost;
  const join = withHost.includes("?") ? "&" : "?";
  return `${withHost}${join}auth=${encodeURIComponent(token)}`;
}
